import { Component, computed, Input, Signal, signal, WritableSignal, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ToastService } from '../../../_services/toast-service/toast.service';
import { getSecondsFromThrottleMsg } from '../../utils/resend-btn-utils';

@Component({
  selector: 'app-resend-btn',
  imports: [NgClass],
  templateUrl: './resend-btn.component.html',
})
export class ResendBtnComponent {
  readonly toastService = inject(ToastService);

  @Input({ required: true }) resend$!: Observable<unknown>;
  @Input({ required: true }) label!: string;
  @Input({ required: true }) btnID!: string;
  @Input() sentMessage: string = 'You will receive a message shortly.';
  @Input() btnClass: string = 'btn btn-light text-secondary';
  @Input() requestMessage: string = 'You can request a new code in';

  interval?: ReturnType<typeof setTimeout>;
  timeoutSeconds: WritableSignal<number> = signal<number>(0);
  timeoutTimer: Signal<string> = computed<string>(() => {
    const minutes: number = Math.floor(this.timeoutSeconds() / 60);
    return `${minutes}:${String(this.timeoutSeconds() % 60).padStart(2, '0')}`;
  });
  btnResendDisabled: Signal<boolean> = computed<boolean>(() => this.timeoutSeconds() > 0);

  startTimer() {
    this.clearTimer();
    this.interval = setInterval(() => {
      this.timeoutSeconds.update((value) => value - 1);
      if (this.timeoutSeconds() <= 0) {
        this.clearTimer();
      }
    }, 1000);
  }

  clearTimer() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  resend() {
    this.resend$.subscribe({
      next: () => {
        this.toastService.show(this.sentMessage);
      },
      error: (error: HttpErrorResponse) => {
        if (error.status == 429) {
          this.timeoutSeconds.set(getSecondsFromThrottleMsg(error.error.detail));
          this.startTimer();
        } else {
          throw error;
        }
      },
    });
  }
}
